<cmps-period-compare
    [periodCompareTitle]="_i18n._9942_PERIOD_COMPARE | translate"
    [dayLabel]="_i18n._830_DAY | translate"
    [weekLabel]="_i18n._829_WEEK | translate"
    [monthLabel]="_i18n._828_MONTH | translate"
    [selectDayLabel]="_i18n._9924_SELECT_THE_DAY | translate"
    [selectTheWeekLabel]="_i18n._9925_SELECT_THE_WEEK | translate"
    [selectTheMonthLabel]="_i18n._9926_SELECT_THE_MONTH | translate"
    [openSelectWeekLabel]="_i18n._9927_OPEN_THIS_SELECT_WEEK | translate"
    [openSelectMonthLabel]="_i18n._9928_OPEN_THIS_SELECT_MONTH | translate"
    [compareLabel]="_i18n._9929_COMPARE | translate"
    [weekData]="_cmpsWeekData"
    [monthData]="_cmpsMonthData"
    [dateSelector]="datepicker"
    (compareAction)="_onSelectAction($event)"
>
</cmps-period-compare>

<ng-template #datepicker>
    <form class="form-inline">
        <div class="date-selector-form-group">
            <div class="input-group">
                <input
                    class="form-control"
                    placeholder=""
                    name="dp"
                    [(ngModel)]="_model"
                    [markDisabled]="isDisabled"
                    ngbDatepicker
                    #picker="ngbDatepicker"
                />
                <div class="input-group-append">
                    <button
                        class="cmps-icon-button--no-bg calender-button"
                        (click)="picker.toggle()"
                    >
                        <cmps-icon svgIcon="calendar"></cmps-icon>
                    </button>
                </div>
            </div>
        </div>
    </form>
</ng-template>
